// extracted by mini-css-extract-plugin
export var orderSummary = "_sa-0";
export var showMoreLessButton = "_sa-1";